import React from "react";
import MailIcon from '@material-ui/icons/Mail';
import PhoneIcon from '@material-ui/icons/Phone';
import { Container } from "reactstrap";
import WhatsAppIcon from '@material-ui/icons/WhatsApp';


export const Footer=()=>(
    <Container fluid tag="footer" className="text-center text-white text-uppercase p-3" style={{backgroundColor:"#3F51B5"}}>
            SIRI JEWELLERS
            <div><a href={"whatsapp://send?phone=91"+"6303396926"} style={{color:"#fff",marginRight:"11px"}}><WhatsAppIcon style={{textAlign:"center"}} /></a>
            <a href="mailto: sreeramt2019@gmail.com" style={{color:"#fff",marginRight:"11px"}}><MailIcon style={{textAlign:"center"}} /></a>
            <a href="tel:6303396926" style={{color:"#fff",marginRight:"11px"}}><PhoneIcon style={{textAlign:"center"}} /></a></div>
        </Container>
)